import { FC } from 'react'

import { Avatar, Box, Text, tokens } from '@factorialco/deprecated-design-system'
import { F0TagRaw } from '@factorialco/f0-react'
import { Masonry, Office, People, Person } from '@factorialco/f0-react/icons/app'

import CollapsibleButton from 'modules/job_catalog/components/JobCatalogTree/CollapsibleButton'
import Line from 'modules/job_catalog/components/JobCatalogTree/Line'
import { NODE_SIZE } from 'modules/job_catalog/hooks/useJobCatalogTree'
import { getTextFromNodeType } from 'modules/job_catalog/lib/nodesUtils'
import { JobCatalogNodeData } from 'modules/job_catalog/pages/JobCatalogTreePage/types'

interface NodeBaseProps {
  data: JobCatalogNodeData
  x: number
  y: number
  onClick?: () => void
  isUncollapsed?: boolean
  hasChildren?: boolean
  onCollapseChange?: () => void
  childrenCount?: number
  selectedNodeId?: string | null
}

interface JobCatalogNodeComponent extends FC<NodeBaseProps> {
  Link: FC<{ d: string }>
}

const JobCatalogNode: JobCatalogNodeComponent = ({
  data,
  x,
  y,
  onClick,
  isUncollapsed = false,
  hasChildren = false,
  onCollapseChange = () => {},
  childrenCount = 0,
  selectedNodeId,
}) => {
  const [width, height] = NODE_SIZE

  const iconMap = {
    family: People,
    function: Masonry,
    role: Person,
    company: Office,
  }

  const isValidType = (type: string): type is keyof typeof iconMap => type in iconMap
  const icon = isValidType(data.type) ? iconMap[data.type] : Person
  const isSelected = selectedNodeId ? data.id === selectedNodeId : false

  return (
    <foreignObject x={x} y={y} width={width} height={height} style={{ overflow: 'visible' }}>
      <Box padding="s12" justifyContent="center" alignItems="center">
        <Box
          position="relative"
          onClick={onClick}
          border={isSelected ? { all: { color: 'viridian800', style: 'solid', width: 's4' } } : {}}
          borderRadius={{ all: 'rel333' }}
          padding="s2"
        >
          <Avatar size="s64" label={data.name} />
        </Box>
        <Text weight="semibold" size="300" whiteSpace="nowrap" ellipsis color="grey1000">
          {data.name}
        </Text>
        <F0TagRaw text={getTextFromNodeType(data.type)} icon={icon} />
        {hasChildren && (
          <Box paddingTop="s8" alignItems="center">
            <Line />
            <CollapsibleButton
              childrenCount={childrenCount}
              isUncollapsed={isUncollapsed}
              onCollapseChange={onCollapseChange}
            />
          </Box>
        )}
      </Box>
    </foreignObject>
  )
}

const Link: FC<{ d: string }> = ({ d }) => {
  return <path d={d} fill="none" stroke={tokens.colors.grey400} strokeWidth="2" />
}

JobCatalogNode.Link = Link

export default JobCatalogNode
